import { render } from "./DetailOpenTrip.vue?vue&type=template&id=9319bc42&scoped=true"
import script from "./DetailOpenTrip.vue?vue&type=script&lang=js"
export * from "./DetailOpenTrip.vue?vue&type=script&lang=js"

import "./DetailOpenTrip.vue?vue&type=style&index=0&id=9319bc42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9319bc42"]])

export default __exports__